import { useEffect, useState } from "react";
import history from "web/script/utils/history";

export function useProductSelector(sortedVariants: string[]): [string, (pid: string) => void] {
    let [currentProduct, setCurrentProduct] = useState(sortedVariants[0]);

    useEffect(() => {
        return history.bindQuery("selected_variant", (action: string, values?: string[]) => {
            let value = values && values[0];
            if (!value || action == "removed") {
                value = sortedVariants[0];
            }
            if (!sortedVariants.includes(value)) {
                console.warn(
                    "Recieved unexpected product %s, acceptable products: %O",
                    value,
                    sortedVariants
                );
                return;
            }
            setCurrentProduct(value);
        });
    }, [sortedVariants]);

    return [
        currentProduct,
        (newVariant: string): void => {
            history.updateQuery("selected_variant", newVariant, false);
        },
    ];
}
